<template>
    <div class="help-content">
        <h1>Postavljanje Fiskalizacije 1.0</h1>
        <p>
            Fiskalizacija 1.0 se odnosi na izdavanje svih računa na kojima su kupci fizičke osobe i izdavanje gotovinskih i kartičnih računa na kojima su kupci pravne osobe.
        </p>
        <p>
            Za postavljanje fiskalizacije potrebno je napraviti nekoliko koraka.<br/>
        </p>
        <ol>
            <li>Postaviti certifikat i njegovu lozinku u financijskim postavkama.</li>
            <li>Postaviti slijed za fiskalizaciju u financijskim postavkama.</li>
            <li>Korisnicima koji će fiskalizirati račune unijeti OIB.</li>
        </ol>
        <h2>Postavljanje certifikata, lozinke i slijeda u financijskim postavkama</h2>
        <p>
            Iz lijevog izbornika je potrebno odabrati <strong>Postavke > Financije</strong>.<br/>
            U polje <strong>Certifikat za fiskalizaciju</strong> je potrebno uploadati datoteku certifikata.<br/>
            U polje <strong>Lozinka certifikata</strong> je potrebno upisati lozinku certifikata.<br/>
            U tablici <strong>Sljedovi brojeva računa</strong> je potrebno postaviti kvačicu u stupcu
            <strong>Fisk. 1.0</strong> za barem jedan slijed.<br/>
            Na kraju je potrebno kliknutu gumb <strong>Spremi</strong> koji se nalazi na vrhu.
        </p>
        <h2>Unošenje OIB-a korisnicima</h2>
        <p>
            Iz lijevog izbornika je potrebno odabrati <strong>Postavke > Korisnici</strong>, te otvoriti korisnika kojem
            želimo dodati OIB.<br/>
            Potrebno je unijeti korisnikov OIB u polje <strong>OIB</strong>.<br/>
            Na kraju je potrebno kliknuti na gumb <strong>Spremi</strong> koji se nalazi na vrhu.<br/>
            Postupak je potrebno ponoviti za sve korisnike koj će fiskalizirati račune.
        </p>
        <h2>Fiskaliziranje računa</h2>
        <p>
            Kod izdavanja računa je u polju <strong>Slijed</strong> potrebno odabrati slijed koji se fiskalizira.<br/>
            Ako imate postavljen samo jedan slijed onda se polje <strong>Slijed</strong> ne vidi i slijed je
            odabran.<br/>
            Takav račun će se automatski pokušati fiskalizirati nakon izdavanja.<br/>
            Ako je došlo do greške prilikom fiskalizacije pojaviti će se crvena ikona pored tog računa u modulu "Računi".<br/>
            Klikom na tu ikonu će Vam aplikacija objasniti što trebate napraviti.
        </p>
        <div class="disclaimer">
            Računi koji su fiskalizirani se ne mogu brisati i mijenjati, ali se mogu stornirati.<br/>
            Predlažemo da se oko postavki fiskalizacije i sljedova posavjetujete sa svojim računovodstvom.<br />
            Budite sigurni da ste ispravno prijavili poslovne prostore Poreznoj i da svi korisnici koji izdaju račune smiju fiskalizirati.
        </div>
    </div>
</template>

<script>

export default {
    name: "HelpFiskal",
    components: {},
    data() {
        return {}
    },
}
</script>

<style scoped>
.disclaimer {
    color: red;
    font-weight: bold;
}

.help-content {
    background: white;
}

.help-content a {
    font-weight: bold;
}
</style>